<section class="flowpay-qr-payment-wrapper">
  <div class="box-container">
    <!-- topic -->
    <div class="qr-payment-topic">
      <!-- desktop heading  -->
      <div
        class="qr-payment-topic__heading qr-payment-topic__heading--desktop color-gray"
        [innerHtml]="'FLOWPAY.QR_PAYMENT.TOPIC.TITLE' | translate"
      ></div>

      <!-- tablet heading  -->
      <div
        class="qr-payment-topic__heading qr-payment-topic__heading--tablet color-gray"
        [innerHtml]="'FLOWPAY.QR_PAYMENT.TOPIC.TITLE' | translate"
      ></div>

      <!-- mobile heading  -->
      <div
        class="qr-payment-topic__heading qr-payment-topic__heading--mobile color-gray"
        [innerHtml]="'FLOWPAY.QR_PAYMENT.TOPIC.TITLE' | translate"
      ></div>

      <div class="qr-payment-topic__heading-detail">{{ 'FLOWPAY.QR_PAYMENT.TOPIC.DETAIL' | translate }} </div>
    </div>

    <!-- content -->
    <div class="box">
      <div class="box__left">
        <div class="title" [innerHtml]="'FLOWPAY.QR_PAYMENT.HEADING' | translate"></div>
        <div class="detail">{{ 'FLOWPAY.QR_PAYMENT.DESCRIPTION' | translate }} </div>
      </div>

      <div class="box__right">
        <div class="box__card">
          <div class="box__card-top">
            <picture>
              <source
                srcset="{{ 'https://flowaccountcdn.com/new_landing/image/functions/flowpay/' + (qrCodeTab == 1  ?  'Statics_QR_Code_v3' : 'Dynamic_QR_Code_v3') + '.webp'}}"
                type="image/webp"
              />
              <source
                srcset="{{ 'https://flowaccountcdn.com/new_landing/image/functions/flowpay/' + (qrCodeTab == 1  ?  'Statics_QR_Code_v3' : 'Dynamic_QR_Code_v3') + '.png'}}"
                type="image/png"
              />
              <img
                src="{{
                  'https://flowaccountcdn.com/new_landing/image/functions/flowpay/' +
                    (qrCodeTab == 1 ? 'Statics_QR_Code_v3' : 'Dynamic_QR_Code_v3') +
                    '.png'
                }}"
                class="box__image"
                alt="{{ qrCodeTab == 1 ? 'Static QR Code' : 'Dynamic QR Code' }}"
                title="{{ qrCodeTab == 1 ? 'Static QR Code' : 'Dynamic QR Code' }}"
                loading="lazy"
                width="100%"
              />
            </picture>
          </div>

          <div class="box__card-bottom">
            <div class="box__tab">
              <div class="item active" [ngClass]="{ active: qrCodeTab === 1 }" (click)="onClickTab(1)"
                >Statics QR Code
              </div>
              <div class="item" [ngClass]="{ active: qrCodeTab === 2 }" (click)="onClickTab(2)">Dynamic QR Code</div>
            </div>

            <div class="box__card-title">{{ 'FLOWPAY.QR_PAYMENT.' + qrCodeTab + '.TITLE' | translate }}</div>
            <div class="box__card-detail">{{ 'FLOWPAY.QR_PAYMENT.' + qrCodeTab + '.DETAIL' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content 2 -->
    <div class="box reverse">
      <div class="box__left">
        <div class="title" [innerHtml]="'FLOWPAY.CREDIT_PAYMENT.HEADING' | translate"></div>
        <div class="detail">{{ 'FLOWPAY.CREDIT_PAYMENT.DESCRIPTION' | translate }} </div>
      </div>

      <div class="box__right">
        <div class="box__card">
          <div class="box__card-top">
            <picture>
              <source
                srcset="https://flowaccountcdn.com/new_landing/image/functions/flowpay/Cradit_Payment_v2.webp"
                type="image/webp"
              />
              <source
                srcset="https://flowaccountcdn.com/new_landing/image/functions/flowpay/Cradit_Payment_v2.jpg"
                type="image/png"
              />
              <img
                src="https://flowaccountcdn.com/new_landing/image/functions/flowpay/Cradit_Payment_v2.jpg"
                class="box__image"
                alt="บริการรับชำระด้วยบัตรเครดิตออนไลน์"
                title="บริการรับชำระด้วยบัตรเครดิตออนไลน์"
                loading="lazy"
                width="100%"
              />
            </picture>
          </div>

          <div class="box__card-bottom">
            <div class="box__card-title" [innerHTML]="'FLOWPAY.CREDIT_PAYMENT.TITLE' | translate"></div>
            <div class="box__card-detail">{{ 'FLOWPAY.CREDIT_PAYMENT.DETAIL' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
